import { delay } from "src/common/delay";

import { FnFocus } from "../types/MdmCardFormTypes";

type AbsRef = {
  focus: () => void;
} | null;
export const focusCtrl = <Ref extends AbsRef>(
  current: Ref,
  focusBk: (onFocus: FnFocus) => void,
) => {
  if (current) {
    focusBk(async () => {
      await delay(10);
      current?.focus();
    });
  } else {
    focusBk(undefined);
  }
  return () => {
    focusBk(undefined);
  };
};
